/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramaModelDto } from '../../models/programa-model-dto';

export interface ProgramasControllerObtenerProgramas$Params {
}

export function programasControllerObtenerProgramas(http: HttpClient, rootUrl: string, params?: ProgramasControllerObtenerProgramas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProgramaModelDto>>> {
  const rb = new RequestBuilder(rootUrl, programasControllerObtenerProgramas.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProgramaModelDto>>;
    })
  );
}

programasControllerObtenerProgramas.PATH = '/api/programas/obtener-programas';
